import React, { Fragment, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom'
import Common from '../../../Shared/Common';
import Block from '../../../Controls/Scafolding/Block';

import { Container, Row, Col, FormGroup, Button, Label, Input, Alert, ListGroup, ListGroupItem } from 'reactstrap';
import { ContentAbout0, ContentAbout1, ContentAbout2, ContentAbout3, ContentAbout4 } from '../Blocks/_ContentBlocks';
import { TextHeader, TextTitle } from '../../../Controls/Digital/TextHeaders';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faSave, faSearch, faTrash } from '@fortawesome/free-solid-svg-icons';
import DataAPI from '../Shared/DataAPI';
import TShirt from './../Resources/Images/TShirt.jpg';


export const RecordLeaderBoard = (props) => {

    const [blockName, setBlockName] = useState("");

    const [comp, setComp] = useState("");

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [date, setDate] = useState("");
    const [location, setLocation] = useState("");
    const [country, setCountry] = useState("");
    const [points, setPoints] = useState("");
    const [weight, setWeight] = useState("");
    const [length, seLength] = useState("");
    const [year, setYear] = useState("2026");

    const [actionSaved, setActionSaved] = useState(false);

    //const [selectedOption, setSelectedOption] = useState("");
    //const [headlandName, setHeadlandName] = useState("");
    //const [headlandNotSelelected, setHeadlandNotSelelected] = useState(false);

    useEffect(() => {
    },[]);

    let onCompChange = function (item, event) {
        setComp(item.target.value);
        Common.trace(item.target.value);
    };

    let onFirstNameChange = function (item, event) {
        setFirstName(item.target.value);
    };
    let onLastNameChange = function (item, event) {
        setLastName(item.target.value);
    };
    let onEmailChange = function (item, event) {
        setEmail(item.target.value);
    };
    let onDateChange = function (item, event) {
        setDate(item.target.value);
    };
    let onLocationChange = function (item, event) {
        setLocation(item.target.value);
    };
    let onCountryChange = function (item, event) {
        setCountry(item.target.value);
    };
    let onPointsChange = function (item, event) {
        setPoints(item.target.value);
    };
    let onWeightChange = function (item, event) {
        setWeight(item.target.value);
    };
    let onLengthChange = function (item, event) {
        seLength(item.target.value);
    };

    let actionCallBack = function (data, callbackData) {
        setActionSaved(true);
    }

    let actionCallbackError = function (data, callbackData) {
        setActionSaved(true);
    }

    return (
        <Block name="submissions" isAlt={false}>
            <TextHeader 
                text={"Sanc Souci Dolphins Competition Leaderboard" - {year}}
            />
            <TextTitle
                text="All the catches!!!"
            />
           
        </Block>
    );
}

